module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("TO")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("MY MILLIONS OF FRIENDS")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("IN THE SOVIET UNION, WHO,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("WHILE THIS BOOK WAS BEING WRITTEN,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("HAVE BEEN DEFENDING")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("OUR COMMON CAUSE.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1-1"
  }, [_c('span', [_vm._v("“Wide is the gate, and broad is the way, that leadeth to destruction.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d3e606","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/dedication.vue
// module id = 78
// module chunks = 0